/* @flow */

import { call, put, take, select } from 'redux-saga/effects'

import type { Action, PollId } from '../types'

import { sagaDelete } from '../fetch'
import { apiUrlForPollWhereId } from '../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  UnauthorizedError,
  NotFoundError,
  sagaHandleUnauthorized,
} from '../helpers'

import { setAlertDanger, setAlertSuccess } from '../stores/alert'
import { goToOldLibrary } from '../stores/routing'
import { setIsDeletingPollWhereId } from '../stores/pending'
import { selectCheckedoutPoll } from '../stores/pollBuilderCheckedoutPoll'
import { clearFeaturedPolls } from '../stores/polls/featured'
import { clearCursors } from '../stores/cursoredUrlsStore'
import {
  deleteFromPollsStoreWhereId,
  selectPollWhereId,
  clearPollsStore,
} from '../stores/pollsStore'
import { clearAutomatedPolls } from '../stores/polls/automated'
import { sagaLogoutUnauthorizedUser } from './logout'

export const POLL_BUILDER_DELETE_BUTTON_CLICK: string =
  'opinary/POLL_BUILDER_DELETE_BUTTON_CLICK'

export function pollBuilderDeleteButtonClick(): Action {
  return {
    type: POLL_BUILDER_DELETE_BUTTON_CLICK,
  }
}

export function* sagaDeletePollWhereId(id: PollId): Generator<*, void, *> {
  const response = yield call(sagaDelete, apiUrlForPollWhereId(id))

  if (response == null) throw new SagaMalfunctionError()
  if (response.status === 401 || response.status === 403) {
    yield call(sagaLogoutUnauthorizedUser)
    throw new UnauthorizedError()
  }
  if (response.status === 404) throw new NotFoundError()
  if (response.status !== 204) throw new BadResponseError(response)
  return response
}

export function* sagaPollBuilderDeleteButtonClick(
  id: PollId
): Generator<*, void, *> {
  const poll = yield select(selectPollWhereId, id)
  if (poll == null) return
  const deletePollResponse = yield call(sagaDeletePollWhereId, id)
  yield put(deleteFromPollsStoreWhereId(id))
  yield put(clearPollsStore())
  yield put(clearFeaturedPolls())
  yield put(clearAutomatedPolls())
  yield put(clearCursors())
  yield put(goToOldLibrary())
  yield put(setAlertSuccess(`Poll ${poll.name} was successfully deleted`))
  return deletePollResponse
}

export function* sagaRepeatedlyPollBuilderDeleteButtonClick(): Generator<
  *,
  void,
  *
> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    yield take(POLL_BUILDER_DELETE_BUTTON_CLICK)

    const poll = yield select(selectCheckedoutPoll)
    if (poll == null) {
      throw new Error('poll delete button clicked but no poll is checked out')
    }

    yield put(setIsDeletingPollWhereId(poll.id, true))
    try {
      const response = yield call(sagaPollBuilderDeleteButtonClick, poll.id)
      console.log('sagaPollBuilderDeleteButtonClick', response)
      if (response.status === 401 || response.status === 403) {
        yield call(sagaLogoutUnauthorizedUser)
        throw new UnauthorizedError()
      }
    } catch (err) {
      if (err instanceof NotFoundError) {
        yield put(goToOldLibrary())
        yield put(
          setAlertDanger('Poll was already deleted or has never existed')
        )
      } else {
        yield call(sagaHandleUnauthorized)
      }
    }
    yield put(setIsDeletingPollWhereId(poll.id, true))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/deletePoll.js